import {action, observable, runInAction} from 'mobx'
import {decorate, inject, injectable} from '@yosmanyga/di'
import {CredentialManager} from '@yosmanyga/base';
import {AuthenticationFrontendWithFacebookAbstractApi} from '../../data'

class AuthenticationFrontendWithFacebookController {
    @observable accessor error!: string
    @observable accessor completing: boolean

    constructor(
        private authenticationFrontendWithFacebookAbstractApi: AuthenticationFrontendWithFacebookAbstractApi,
        private credentialManager: CredentialManager,
    ) {
        this.completing = false
    }

    @action complete = async (
        code: string,
        verifier: string
    ) => {
        runInAction(() => {
            this.completing = true
        })

        const credential = await this.authenticationFrontendWithFacebookAbstractApi.complete(code, verifier)
        await this.credentialManager.save(credential);

        runInAction(() => {
            this.completing = false
        })
    }
}

decorate(injectable(), AuthenticationFrontendWithFacebookController)
decorate(inject(AuthenticationFrontendWithFacebookAbstractApi), AuthenticationFrontendWithFacebookController, 0)
decorate(inject(CredentialManager), AuthenticationFrontendWithFacebookController, 1)

export {
    AuthenticationFrontendWithFacebookController
}
